define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/table/matrix/Path"
], function(array,declare,PathMatrix) {

	return declare(PathMatrix, {
		_filterNodes: function(/*Context*/ctx, /*Spec*/spec, /*Node[]*/nodes) {
			// summary: show only colors that reference current promo
			var	urlPromo = ctx.getParentURL();

			return array.filter(nodes, function(node) {
				return array.indexOf(node.ColorPromos, urlPromo) >= 0;
			});
		}
	});
});